import React, { Component } from "react";
import { Row, Col, Card, Table, Modal, ModalHeader, Button } from "reactstrap";
import CgnAlert from "../toolbox/CgnAlert";
import CgnLoader from "../toolbox/CgnLoader";
import CgnButtonLink from "../toolbox/CgnButtonLink";
import ContentTop from "../root/ContentTop";
import axios from "axios";
import {
  URL,
  fotoStyle,
  
  localFilePath,
  fotoStyle2,
} from "../../redux/actions/constants";
import noImg from "../../images/no-img.png";
import pdfIcon from "../../images/pdfIcon.png";

class SieveProductDetail extends Component {
  state = {
    pageTitle: "Ürün Detay",
    pageTitleDetail: "Ürün Detay",
    pageAddLink: "urun2-ekle",
    pageListLink: "urun2-listele",
    breadcrumb: [{ text: "Ürün", link: "#" }],
    isLoading: false,
    alertErrorMessage: "",
    image: "",
    categoryName: "",
    contractName: "",
    code: "",
    name: "",
    description: null,
    criticalPieces: null,
    currencyType: "",
    salePrice: "",
    buyPrice: "",
    peerProductName: "",
    supplierProductCode: "",
    status: "",
    createdBy: "",
    createdAt: "",
    updatedAt: "",
    updatedBy: "",
    costType: "",
    sieveProductPropertyDto: [],
    stockStatus: false,
    productStock: 0,
    machineSize: "",
    sieveSize: "",
    sieveEyeSize: "",
    locationProductStock: [],
    sieveProductImageDto: [],
    offerNumbers: "",
  };

  async componentDidMount() {
    let urlSplit = window.location.pathname.split("/");
    if (urlSplit.length === 3) {
      this.setState({
        pageTitle: this.state.pageTitleDetail,
        isLoading: true,
      });
      // 
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      axios
        .get(URL + "/sieveProducts/get/" + urlSplit[2], config)
        .then((response) => {
          this.setState({
            categoryName: response.data.categoryName,
            contractName: response.data.contractName,
            code: response.data.code,
            supplierProductCode: response.data.supplierProductCode,
            name: response.data.name,
            criticalPieces: response.data.criticalPieces,
            currencyType: response.data.currencyType,
            sieveProductPropertyDto: response.data.sieveProductPropertyDto,
            peerProductName: response.data.peerProductName,
            salePrice: response.data.salePrice.toLocaleString("tr-TR", {
              minimumFractionDigits: 2,
            }),
            buyPrice: response.data.buyPrice.toLocaleString("tr-TR", {
              minimumFractionDigits: 2,
            }),
            status: response.data.status,
            createdBy: response.data.createdBy,
            createdAt: response.data.createdAt,
            updatedBy: response.data.updatedBy,
            updatedAt: response.data.updatedAt,
            stockStatus: response.data.stockStatus,
            productStock: response.data.productStock,
            locationProductStock: response.data.locationProductStock,
            description: response.data.description,
            sieveSize: response.data.sieveSize,
            sieveEyeSize: response.data.sieveEyeSize,
            machineSize: response.data.machineSize,
            sieveProductImageDto: response.data.sieveProductImageDto,
            costType: response.data.costType,
            offerNumbers: response.data.offerNumbers,
            isLoading: false,
            productGroupName: response.data.productGroupName,
          });
        })
        .catch((error) => {
          this.setState({
            alertErrorMessage: error.response.data,
            isLoading: false,
          });
        });
    }
  }

  toggle = () => {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  };

  toggle = (image) => {
    this.setState({
      isOpen: !this.state.isOpen,
      isImage: image,
    });
  };

  fileClick = (image) => {
    var myData = image;
    let replaceLink = myData.replace(localFilePath + "/Files/", "");
    if (replaceLink) {
      window.open("/Files/" + myData, "_blank");
      this.setState({
        isLoading: false,
      });
    }
  };

  render() {
    const mainRow = {
      backgroundColor: "#1d4b8c",
      color: "#fff",
    };
    const subRow = {
      backgroundColor: "#f2f2f2",
    };
    var self = this.state;
    var self1 = this;
    return (
      <>
        <ContentTop
          breadcrumb={this.state.breadcrumb}
          title={this.state.pageTitle}
          addLink={"/" + this.state.pageAddLink}
          listLink={"/" + this.state.pageListLink}
        />
        <Row>
          <Col>
            <Card body className="table-responsive">
              <CgnLoader visibled={this.state.isLoading} />
              {this.state.alertErrorMessage && (
                <CgnAlert
                  color="danger"
                  title="Uyarı"
                  text={this.state.alertErrorMessage}
                />
              )}
              <Table className="table table-responsive table-hover">
                <tbody>
                  <tr>
                    <th>Kategori Adı</th>
                    <td colSpan="4">
                      {this.state.categoryName ? this.state.categoryName : "-"}
                    </td>
                  </tr>
                  <tr>
                    <th>Ürün Grubu</th>
                    <td colSpan="4">
                      {this.state.productGroupName ? this.state.productGroupName : "-"}
                    </td>
                  </tr>
                  <tr>
                    <th>Barkod</th>
                    <td colSpan="4">
                      {this.state.code ? this.state.code : "-"}
                    </td>
                  </tr>

                  <tr>
                    <th>Tedarikçi Ürün Kodu</th>
                    <td colSpan="4">
                      {this.state.supplierProductCode ? this.state.supplierProductCode : "-"}
                    </td>
                  </tr>

                  <tr>
                    <th>Ürün Adı</th>
                    <td colSpan="4">
                      {this.state.name ? this.state.name : "-"}
                    </td>
                  </tr>

                  <tr>
                    <th>Makine Boyutu</th>
                    <td colSpan="4">
                      {this.state.machineSize ? this.state.machineSize : "-"}
                    </td>
                  </tr>

                  <tr>
                    <th>Elek Boyutu</th>
                    <td colSpan="4">
                      {this.state.sieveSize ? this.state.sieveSize : "-"}
                    </td>
                  </tr>

                  <tr>
                    <th>Elek Göz Boyutu</th>
                    <td colSpan="4">
                      {this.state.sieveEyeSize ? this.state.sieveEyeSize : "-"}
                    </td>
                  </tr>

                  <tr>
                    <th>Tür</th>
                    <td colSpan="4">
                      {this.state.costType === 1 ? "Döküm" : this.state.costType === 2 ? "TPU" : "-"}
                    </td>
                  </tr>

                  <tr>
                    <th>Emsal Ürün</th>
                    <td colSpan="4">
                      {this.state.peerProductName
                        ? this.state.peerProductName
                        : "-"}
                    </td>
                  </tr>

                  <tr>
                    <th>Alış Fiyatı</th>
                    <td colSpan={4}>
                      {this.state.buyPrice
                        ? this.state.buyPrice.toLocaleString("tr-TR", {
                          minimumFractionDigits: 2,
                        }) +
                        " " +
                        (this.state.currencyType === 1
                          ? "₺"
                          : this.state.currencyType === 2
                            ? "$"
                            : this.state.currencyType === 3
                              ? "€"
                              : "-")
                        : "-"}
                    </td>
                  </tr>

                  <tr>
                    <th>Satış Fiyatı</th>
                    <td colSpan="4">
                      {this.state.salePrice
                        ? `${this.state.salePrice} ${this.state.currencyType === 1
                          ? "₺"
                          : this.state.currencyType === 2
                            ? "$"
                            : this.state.currencyType === 3
                              ? "€"
                              : "-"
                        }`
                        : "-"}
                    </td>
                  </tr>

                  <tr>
                    <th>Stok Durumu</th>
                    <td colSpan="4">
                      {this.state.stockStatus ? "Stoklu Ürün" : "Stoksuz Ürün"}
                    </td>
                  </tr>

                  {this.state.stockStatus ? (
                    <>
                      <tr>
                        <th>Stok</th>
                        <td colSpan="4">{this.state.productStock + " Adet"}</td>
                      </tr>
                      <tr>
                        <th>Kritik Adet</th>
                        <td colSpan="4">
                          {this.state.criticalPieces + " Adet"}
                        </td>
                      </tr>
                    </>
                  ) : (
                    ""
                  )}

                  <tr>
                    <th>Açıklama</th>
                    <td colSpan="4">{this.state.description === null ? "-" : this.state.description}</td>
                  </tr>

                  <tr>
                    <th>Sipariş Numaraları</th>
                    <td colSpan="4">{this.state.offerNumbers === "" ? "-" : this.state.offerNumbers}</td>
                  </tr>

                  <tr>
                    <th>Durumu</th>
                    <td colSpan="4">{this.state.status ? "Aktif" : "Pasif"}</td>
                  </tr>

                  <tr>
                    <th>Kaydeden Kullanıcı</th>
                    <td>{this.state.createdBy ? this.state.createdBy : "-"}</td>
                    <th>Kaydedilme Tarihi</th>
                    <td>{this.state.createdAt ? this.state.createdAt : "-"}</td>
                  </tr>
                  <tr>
                    <th>Son Güncelleyen Kullanıcı</th>
                    <td>{this.state.updatedBy ? this.state.updatedBy : "-"}</td>
                    <th>Son Güncellenme Tarihi</th>
                    <td>{this.state.updatedAt ? this.state.updatedAt : "-"}</td>
                  </tr>
                </tbody>
              </Table>


              {this.state.locationProductStock !== null &&
                this.state.locationProductStock.length > 0 && (
                  <Table className="table table-responsive table-hover table-product">
                    <tr style={mainRow}>
                      <th>Depo</th>
                      <th>Stok</th>
                    </tr>
                    {this.state.locationProductStock.map(function (item) {
                      return (
                        <tr style={subRow}>
                          <td>{item.locationName}</td>
                          <td>{item.piece + " Adet"}</td>
                        </tr>
                      );
                    })}
                  </Table>
                )}

              {this.state.sieveProductPropertyDto !== null &&
                this.state.sieveProductPropertyDto.length > 0 && (
                  <Table className="table table-responsive table-hover table-product table-product-2">
                    <tr style={mainRow}>
                      <th>Ürün Özellikleri Tipi</th>
                      <th>Ürün Özellikleri</th>
                    </tr>
                    {this.state.sieveProductPropertyDto.map(function (item) {
                      return (
                        <tr style={subRow}>
                          <td>{item.propertyTypeName}</td>
                          <td>{item.value}</td>
                        </tr>
                      );
                    })}
                  </Table>
                )}

              {this.state.sieveProductImageDto !== null &&
                this.state.sieveProductImageDto.length > 0 && (
                  <>
                    <Table className="table table-responsive table-hover table-product2">
                      <tr style={mainRow}>
                        <th>Ürün Fotoğrafı</th>
                      </tr>
                      <Row>
                        {this.state.sieveProductImageDto.map(function (item) {
                          return (
                            <>
                              <div className="pl-4">
                                {item.image ? (
                                  <Button
                                    onClick={() => self1.toggle(item.image)}
                                    className="modalButtonDetail"
                                  >
                                    <img
                                      src={item.image}
                                      style={fotoStyle}
                                      alt={item.errorCodeName}
                                    />
                                  </Button>
                                ) : (
                                  <img
                                    src={noImg}
                                    style={fotoStyle}
                                    alt={item.errorCodeName}
                                  />
                                )}
                              </div>
                              <Modal isOpen={self.isOpen} toggle={self1.toggle}>
                                <ModalHeader
                                  toggle={self1.toggle}
                                ></ModalHeader>
                                <img
                                  className="modalImage"
                                  src={self.isImage}
                                  style={fotoStyle}
                                  alt={item.errorCodeName}
                                />
                              </Modal>
                            </>
                          );
                        })}
                      </Row>
                    </Table>
                  </>
                )}

            </Card>
            <CgnButtonLink
              color="secondary"
              to={"/" + this.state.pageListLink}
              text="Geri"
              className="btn-back"
            />
          </Col>
        </Row>
      </>
    );
  }
}

export default SieveProductDetail;
